module.exports = __webpack_public_path__ + "/fonts/Material-Design-Iconic-Font.woff";


//////////////////
// WEBPACK FOOTER
// ./app/fonts/Material-Design-Iconic-Font.woff
// module id = 631
// module chunks = 0